// icons/IconRegistry.ts
import SearchIcon from '@mui/icons-material/Search';
import UserIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import FourDots from "../../../../../public/staticwebapp.config.json"
import { PaletteOutlined, BuildCircleOutlined, CopyAllOutlined, DarkMode, DarkModeOutlined, Delete, DeleteOutline, DonutLargeOutlined, FileUploadOutlined, FilterCenterFocusOutlined, HomeOutlined, HomeRounded, InfoOutlined, LightMode, LightModeOutlined, LogoutOutlined, MessageOutlined, MoodOutlined, MoreHorizOutlined, SaveOutlined, StopCircle, TuneOutlined, WorkspacesRounded, Psychology, SettingsOutlined, CopyAllRounded, ContentCopyRounded, CropSquareSharp, CancelOutlined, Circle, CircleOutlined, CheckCircle, ArrowBack, RefreshOutlined } from '@mui/icons-material';
import { GoogleIcon } from '../GoogleIcon';

// Exporting Material UI icons as a centralized registry
export const iconRegistry = {
  search: SearchIcon,
  user: UserIcon,
  home: HomeRounded,
  clear: DeleteOutline,
  darkMode: DarkModeOutlined,
  lightMode: LightModeOutlined,
  logout: LogoutOutlined,
  fourDots: FilterCenterFocusOutlined,
  info: InfoOutlined,
  upload: FileUploadOutlined,
  google: GoogleIcon,
  settings: TuneOutlined,
  copy: ContentCopyRounded,
  message: MessageOutlined,
  threeDots: MoreHorizOutlined,
  knowledgebase: CopyAllOutlined,
  save: SaveOutlined,
  delete: CancelOutlined,
  trash: DeleteOutline,
  refresh: RefreshOutlined,
  bullet: Circle,
  success: CheckCircle,
  back: ArrowBack,
  stop: StopCircle,
  paletteOutlined: PaletteOutlined,
  settings2: SettingsOutlined
};

// TypeScript type for the registry keys
export type IconName = keyof typeof iconRegistry;
